import { styled, Box, Slider } from "@mui/material";

const VideoPlayerRoot = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  background: "#C06674", 
  height: "3.6rem",
  pointerEvents: "all",
}));

 

export { VideoPlayerRoot };
